exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1_5jgZgfVEVFyd{text-align:center}._1_5jgZgfVEVFyd strong{line-height:36px}", ""]);

// exports
exports.locals = {
	"container": "_1_5jgZgfVEVFyd"
};